import { render, staticRenderFns } from "./Nota-votada.vue?vue&type=template&id=68dc8a89&"
import script from "./Nota-votada.vue?vue&type=script&lang=js&"
export * from "./Nota-votada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports